import { useState } from "react";

export default function Texting() {
  const [message, setMessage] = useState("");
  const [numbers, setNumbers] = useState("");
  const [isSending, setIsSending] = useState(false);
  const [result, setResult] = useState(null);

  const recipients = numbers
    .split(",")
    .map(n => n.trim())
    .filter(n => n.length > 0);

  const handleSend = async () => {
    if (!message.trim()) {
      return setResult({ type: "error", text: "Message is required." });
    }

    if (recipients.length === 0) {
      return setResult({ type: "error", text: "Add at least one phone number." });
    }

    setIsSending(true);
    setResult(null);

    try {
      const res = await fetch("/api/send-mass-text", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message, recipients })
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Failed to send");

      setResult({
        type: "success",
        text: `Sent to ${recipients.length} recipients`
      });

      setMessage("");
      setNumbers("");
    } catch (err) {
      setResult({
        type: "error",
        text: err.message
      });
    }

    setIsSending(false);
  };

  return (
    <div className="mass-text-container">
      <h2>Mass Text Sender</h2>

      <label>Message</label>
      <textarea
        value={message}
        onChange={e => setMessage(e.target.value)}
        maxLength={160}
        placeholder="Type your message here..."
      />
      <div className="meta">
        {message.length}/160 characters
      </div>

      <label>Phone Numbers (comma separated)</label>
      <textarea
        value={numbers}
        onChange={e => setNumbers(e.target.value)}
        placeholder="+13175551234, +13175559876"
      />
      <div className="meta">
        {recipients.length} recipient(s)
      </div>

      <button onClick={handleSend} disabled={isSending}>
        {isSending ? "Sending..." : "Send Texts"}
      </button>

      {result && (
        <div className={`result ${result.type}`}>
          {result.text}
        </div>
      )}
    </div>
  );
}